import React from 'react'
import classNames from 'classnames'

type Props = {
  children?: React.ReactNode
  className?: string
}

export const ModalDialogContent = ({ children, className }: Props) => {
  return <div className={classNames('c-dialog__content', className)}>{children}</div>
}
